export enum DeviceType {
  DESKTOP,
  MOBILE,
  TABLET
}
